import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import masterFormsActions from "../../redux/masterForms/actions";
import CreateMasterModal from "./modals/createMasterModal";
import { useForm } from "react-hook-form";
import EditMasterModal from "./modals/editMasterModal";
import commonActions from "../../redux/common/actions";
import { Box, Radio } from "@mui/material";
import Searchbar from "../../common/searchbar";
import MauvelousPrimaryButton from "../../common/button/mauvelousPrimaryButton";
import DataTable from "../../common/dataTable";
import TablePagination from "../../common/tablePagination";
import { itemsPerPage } from "../../utils/constants";
import BrowseUploadButton from "../../common/button/browseUploadButton";
import { MdOutlinePictureAsPdf } from "react-icons/md";
import masterActions from "../../redux/master/actions";
import BulkUploadModal from "./modals/bulkUploadModal";
import { PiPlusBold } from "react-icons/pi";

const tableKeys = [
  {
    name: "SI.NO",
    accessor: "id",
    // accessor: 'genderid',
    sortOption: false,
  },
  {
    name: "Marital Status",
    accessor: "maritalstatus",
    sortOption: false,
  },
  {
    name: "Marital Status Code",
    accessor: "maritalstatuscode",
    sortOption: false,
  },
  {
    name: "Enable",
    accessor: "enable",
    sortOption: false,
  },
  {
    name: "Disable",
    accessor: "disable",
    sortOption: false,
  },
];

export default function MaritalStatusMaster() {
  const dispatch = useDispatch();

  const { maritalStatusList } = useSelector(
    (state) => state.masterFormsReducer
  );

  const { backofficeTokenDetails } = useSelector((state) => state.authReducer);

  const [itemOffset, setItemOffset] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    getValues,
    trigger,
  } = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
    defaultValues: {},
  });

  useEffect(() => {
    dispatch({ type: masterFormsActions.GET_MARITAL_STATUS });
    //eslint-disable-next-line
  }, []);

  const handleActive = (active, type, maritalstatusid) => {
    if (type !== active) {
      let data = {
        userid: backofficeTokenDetails?.id,
        id: maritalstatusid,
        idname: "maritalstatusid",
        status: type,
        action: masterFormsActions.GET_MARITAL_STATUS,
      };

      dispatch({
        type: masterActions.SET_MASTERS_STATUS,
        payload: data,
      });
    }
  };

  const endOffset = itemOffset + itemsPerPage;
  const currentItems = maritalStatusList?.filtered
    ?.map((obj) => {
      return {
        ...obj,
        enable: (
          <Radio
            checked={obj.status === "1"}
            onClick={() => handleActive(obj.status, "1", obj.maritalstatusid)}
          />
        ),
        disable: (
          <Radio
            checked={obj.status === "0"}
            onClick={() => handleActive(obj.status, "0", obj.maritalstatusid)}
          />
        ),
      };
    })
    ?.slice(itemOffset, endOffset);
  const pageCount = Math.ceil(
    maritalStatusList?.filtered?.length / itemsPerPage
  );

  const handlePageChange = (event, value) => {
    const newOffset = (value - 1) * itemsPerPage;
    setItemOffset(newOffset);
    setCurrentPage(value);
  };

  const handleCreate = (data) => {
    data["maritalstatusid"] = parseInt(data.maritalstatusid);
    data["maritalstatus"] = data.name;
    data["maritalstatuscode"] = data.maritalstatuscode;
    data["userid"] = Number(backofficeTokenDetails?.id);
    dispatch({
      type: masterFormsActions.CREATE_MARITAL_STATUS,
      payload: { data: data, resetForm: resetForm },
    });
  };

  const resetForm = () => {
    reset({
      name: "",
      maritalstatuscode: "",
    });
  };

  const handleSearch = (e) => {
    let filtered = [];
    setCurrentPage(1);
    setItemOffset(0);
    if (e.target.value) {
      //eslint-disable-next-line
      filtered = maritalStatusList?.all?.filter((val) => {
        if (
          val?.maritalstatus
            ?.toLowerCase()
            .includes(e.target.value?.toLowerCase())
        ) {
          return val;
        }
      });
    } else {
      filtered = [...maritalStatusList?.all];
    }
    dispatch({
      type: masterFormsActions.SET_MARITAL_STATUS,
      payload: { ...maritalStatusList, filtered: filtered },
    });
  };

  const handleMasteredit = (page, value) => {
    dispatch({
      type: commonActions.SET_SHOW_MODAL,
      payload: { show: true, type: page, method: "U", data: null },
    });
    reset({
      name: value?.maritalstatus,
      maritalstatuscode: value?.maritalstatuscode,
      maritalstatusid: value?.maritalstatusid,
      userid: value?.userid,
    });
  };

  const handleUpdate = (data) => {
    data["maritalstatusid"] = parseInt(data.maritalstatusid);
    data["maritalstatus"] = data.name;
    data["maritalstatuscode"] = data.maritalstatuscode;
    data["userid"] = Number(backofficeTokenDetails?.id);
    dispatch({
      type: masterFormsActions.UPDATE_MARITAL_STATUS,
      payload: { id: data?.maritalstatusid, data: data, resetForm: resetForm },
    });
  };

  const handleshowModal = () => {
    dispatch({
      type: commonActions.SET_SHOW_MODAL,
      payload: { show: true, type: "maritalstatus", method: "C", data: null },
    });
  };

  return (
    <>
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          marginTop: "24px",
          marginBottom: "14px",
        }}
      >
        {/* <Box></Box> */}
        <Searchbar height={48} handleSearch={handleSearch} />
        <MauvelousPrimaryButton
          title={"Add"}
          icon={<PiPlusBold />}
          handleClick={handleshowModal}
        />
      </Box>
      <Box sx={{ height: "calc(100vh - 280px)" }}>
        <DataTable
          keys={tableKeys}
          values={currentItems}
          page={"maritalstatus"}
          handleMasteredit={handleMasteredit}
        />
      </Box>
      <Box
        sx={{
          position: "fixed",
          bottom: 0,
          right: "24px",
          padding: "15px 0",
          width: "100%",
          py: 1,
        }}
      >
        <TablePagination
          pageCount={pageCount}
          handlePageChange={handlePageChange}
          currentPage={currentPage}
        />
      </Box>
      <CreateMasterModal
        register={register}
        getValues={getValues}
        trigger={trigger}
        handleSubmit={handleSubmit}
        errors={errors}
        handleCreate={handleCreate}
        resetForm={resetForm}
      />
      <EditMasterModal
        register={register}
        handleSubmit={handleSubmit}
        getValues={getValues}
        trigger={trigger}
        errors={errors}
        handleUpdate={handleUpdate}
        resetForm={resetForm}
      />
      <BulkUploadModal />
    </>
  );
}
